import { Grid, Typography } from '@mui/material'

import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import Anchor from '@ecm/ui/element/Anchor'
import MainContainer from '@ecm/ui/element/MainContainer'
import DefaultLayout from '@ecm/ui/layout/Default'

const ContactPage = () => (
  <DefaultLayout hideFinalCta seoPage="contact">
    <PlainHeader title="Contact Us">
      <Grid container direction="column" alignItems="center">
        <Typography variant="p2">Our lines are open from Monday–Friday</Typography>
        <Typography variant="p2" my="0.5em">
          Give us a call at (210) 802-5211
        </Typography>
        <Typography variant="p2" my="0.5em">
          8:00am–5:00pm Central time
        </Typography>
      </Grid>
    </PlainHeader>
    <MainContainer>
      <Grid display="grid" gridTemplateRows="auto" margin="3em 0">
        <Grid container direction="column" alignItems="center" textAlign="center">
          <Typography variant="h4" component="h2">
            Customer Support
          </Typography>
          <Typography variant="p2" my="0.5em">
            Log into your account and create a support ticket on our{' '}
            <Anchor href="https://help.earthclassmail.com" variant="p2" external>
              Help
            </Anchor>{' '}
            page
          </Typography>
          <Typography variant="p2" my="0">
            or
          </Typography>
          <Typography variant="p2" my="0.5em">
            Send us a message at support@earthclassmail.com
          </Typography>
        </Grid>
      </Grid>
    </MainContainer>
  </DefaultLayout>
)

export default ContactPage
